@if (blogContentlet$ | async; as contentlet) { @if (currentPageURI$ | async; as URI) { @if (URI === '/blog/post/' +
contentlet?.urlTitle) {
<custom-dot-cms-blog-detail [contentlet]="contentlet" [identifier]="contentlet.identifier" />
} @else {
<custom-dot-cms-blog-post [contentlet]="contentlet" [identifier]="contentlet.identifier" />
} } }
